var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"blackMedium--text bodyLt py-0"},[_vm._v(" "+_vm._s(_vm.title)+" Items ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }